import { Box, IconButton, Paper, Typography } from "@mui/material"
import { CustomTabPanel } from "../close_daily"
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { useEffect, useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import LayersIcon from '@mui/icons-material/Layers';
import BallotIcon from '@mui/icons-material/Ballot';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { convertArrayOfObjectsToCSV } from "src/shared/util/functions";
import Grid from "@mui/material/Grid2";
import TuneIcon from '@mui/icons-material/Tune';
import SelectBoxSearch from "src/shared/components/select_box_search";
import { Filter, FilterDrawer, FilterList } from "src/shared/modules/filterDrawer";
import { idID } from "@mui/material/locale";
import SummaryLandOccidente from "./summaries/summary_occidente_land";

const internalTabs = [
    { "name": "Resumen", "value": "Resumen", icon: <TextSnippetIcon /> },
    { "name": "Analizados", "value": "analyzed", icon: <LayersIcon /> },
    { "name": "Visitados", "value": "activitiesShouldBeAnalyzed", icon: <BallotIcon /> },
]

const filtersStatics:FilterList[] = [
    {
        name: 'Pozo',
        field: 'pozos',
        type: 'text',
        action: 'textContains',
        buttons: [],
        options: []
    },
    {
        name: 'Metodo',
        field: 'method',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['BM','BCP']
    },
    {
        name: 'Campo',
        field: 'field',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Bachaquero', 'Lagunillas']
    },
    {
        name: 'Analizados',
        field: 'analyzed',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: "", action: 'dissable' },
            { id: 1, name: 'SI', value: 0, action: 'greater' },
            { id: 2, name: 'NO', value: 1, action: 'less' }
        ],
        options: []
    },
    {
        name: 'Sector',
        field: 'zone',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["BTS1", "BTS2", "BTN2", "BTN3", "BTNB", "LGN2", "LGS1", "LGN1", "LGS2", "BTNA"]
    },
    {
        name: 'Estado Operativo Inicio',
        field: 'estadoOperativoInicial',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Operando', 'Sin Aporte', 'Aportando', 'Restaurado', 'Recolocado', 'Sin Producción', 'IT', 'Sin Acceso', 'Observación']
    },
    {
        name: 'Estado Operativo Fin',
        field: 'estadoOperativoFinal',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Operando', 'Sin Aporte', 'Aportando', 'Restaurado', 'Recolocado', 'Sin Producción', 'IT', 'Sin Acceso', 'Observación']
    }
]

export const AnalistsComponent = ({ value, inputData, report, reportFilters }: { value: any, inputData: any, report:any, reportFilters:any }) => {

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0])
    const paginationModel = { page: 0, pageSize: 10 };
    const [columns, setColumns] = useState<GridColDef[]>()
    const [showFilters, setshowFilters] = useState(false)
    const [data, setData] = useState<any[]>()
    const [filteredData, setFilteredData] = useState<Filter[]>([]);
    const [filters, setFilters] = useState<FilterList[]>([])
  

    useEffect(() => {

        const filters = [...filtersStatics]
      
        const analyzedFor = inputData?.analyzed?.map((x:any)=>x.analizadoPor)

        const uniqueAnalyzedFor = Array.from(new Set(analyzedFor));
        
        filters.push({
            name: 'Analizado Por',
            field: 'analizadoPor',
            type: 'Autocomplete',
            action: 'include',
            buttons: [],
            options: uniqueAnalyzedFor
        });

        setFilters(filters)
    }, [inputData])
    
    useEffect(() => {

        const columnsToOmit = ["fieldActivityId"]

        if (activeSummaryView.value === "Resumen") {
            setData(undefined)
            setColumns(undefined)

        } else {
            const data: any[] = []
            const columns: GridColDef[] = []

            if (inputData && inputData?.[activeSummaryView.value]?.length > 0) {

                const firstItem = inputData?.[activeSummaryView.value][0]

                Object.keys(firstItem).forEach((key) => {
                    if (columnsToOmit.includes(key)) return
                    columns.push({
                        field: key,
                        headerName: key,
                        // flex: 1,
                        width: 150,
                    })
                })

                let allData:any[] = inputData?.[activeSummaryView.value] || [];

                for (const filter of filters) {
                    const filterData = filteredData.find(f => f.name === filter.name);
                    if (filterData) {
                        if (filterData.action === 'greater') {
                            allData = allData.filter((x) => x[filter.field] > filterData.value);
                        } else if (filterData.action === 'less') {
                            allData = allData.filter((x) => x[filter.field] < filterData.value);
                        } else if (filterData.action === 'equal') {
                            allData = allData.filter((x) => x[filter.field] === filterData.value);
                        } else if (filterData.action === 'different') {
                            allData = allData.filter((x) => x[filter.field] !== filterData.value);
                        } else if (filterData.action === 'dissable') {
                            allData = allData || [];
                        } else if (filterData.action === 'include' && filterData.value.length > 0) {
                            allData = allData.filter((x) => filterData.value.includes(x[filter.field]));
                        } else if (filterData.action === 'textContains' && filterData.value) {
                            allData = allData.filter((x) => x[filter.field]?.toLowerCase().includes(filterData.value.toLowerCase()));
                        }
                    }
                }

                
                allData?.forEach((req: any, i: number) => {
                    data.push({
                        id: i,
                        ...req
                    })
                })
            }
            setColumns(columns)
            setData(data)
        }
    }, [activeSummaryView, filteredData])


    const onClickChangeSummaryView = (tab: any) => {
        setactiveSummaryView(tab)
    }

    const handleDownloadCSV = () => {
        try {
            if (data && data.length > 0) {
                const csv = convertArrayOfObjectsToCSV(data);
                const utf8Bom = "\uFEFF"; // UTF-8 BOM
                const csvWithBom = utf8Bom + csv;
                const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                const currentTime = new Date().toISOString().replace(/[:.]/g, "-");
                a.setAttribute("download", `${activeSummaryView.name}_${currentTime}.csv`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            console.log({ error });
        }
    }

    const handleSelectOptionFilter = (filter: Filter) => {
        const extraFilter = filteredData.filter(f => f.name !== filter.name);
        setFilteredData([...extraFilter, filter]);
    };

    return (
        <CustomTabPanel value={value} index={0}>
            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 3, gap: 2 }}>
                    {
                        internalTabs.map((item, index) => {
                            return (
                                <IconButton
                                    onClick={() => onClickChangeSummaryView(item)}
                                    key={index}
                                    className="active_button"
                                    sx={{
                                        backgroundColor: activeSummaryView?.value === item.value ? "#1976d2" : "#f0f0f0",
                                        color: activeSummaryView?.value === item.value ? "#fff" : "#000",
                                        "&:hover": {
                                            backgroundColor: activeSummaryView?.value === item.value ? "#42a5f5" : "#f0f0f0",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </IconButton>
                            )
                        })
                    }
                </Box>
                {/* Buttons Left */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, }}>
                    <IconButton
                        onClick={handleDownloadCSV}
                        sx={{
                            backgroundColor: "lightgrey",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#03365e",
                            },
                            ml: 2,
                        }}
                    >
                        <DownloadIcon />
                    </IconButton>
                </Box>
            </Box>
            <Grid size={12} sx={{ mt: 2 }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignContent: "center",
                    }}
                >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                        {activeSummaryView?.name}
                    </Typography>
                    {activeSummaryView?.value !== "Resumen" && (
                        <IconButton
                            size="small"
                            color="primary"
                            sx={{ mr: 2 }}
                            onClick={() => setshowFilters(!showFilters)}
                        >
                            <TuneIcon />
                        </IconButton>
                    )}
                </Box>
            </Grid>
            <FilterDrawer
                showFilters={showFilters}
                filters={filters}
                filteredData={filteredData}
                setshowFilters={setshowFilters}
                handleSelectOptionFilter={handleSelectOptionFilter}
            />
            {(data && columns) && (
                <Paper sx={{ height: '55vh', width: '100%' }}>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{ border: 0 }}
                    />
                </Paper>
            )}

            {(report?.code==="nb-gt-009"&&activeSummaryView.value==="Resumen")&&(<SummaryLandOccidente data={inputData} reportFilters={reportFilters}/>)}

        </CustomTabPanel>
    )
}